import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { ReactNode } from "react";
import { FormattedMessage as T } from "react-intl";

type CloseDialogProps = {
  dialogTitleKey: string;
  contentKey?: string;
  rawContent?: ReactNode;
  open: boolean;
  onClose: () => void;
};

const CloseDialog = ({
  dialogTitleKey,
  contentKey,
  rawContent,
  open,
  onClose,
}: CloseDialogProps) => {
  return (
    <Dialog open={open} disableEnforceFocus>
      <DialogTitle>
        <T id={dialogTitleKey} />
      </DialogTitle>
      <DialogContent dividers>
        {!!contentKey && <T id={contentKey} />}
        {rawContent}
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={onClose}
          color="primary"
          data-cy="closeButton"
        >
          <T id="closeButton" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseDialog;
